export default __webpack_public_path__ + "static/media/CLICHY (172 sur 176).4719ab76.jpg";